export default __webpack_public_path__ + "static/media/facebook-icon.545ec8ae.svg";